import React, { createContext, useState, useContext } from 'react';

const CartContext = createContext();

export const useCart = () => useContext(CartContext);

export const CartProvider = ({ children }) => {
  const [cart, setCart] = useState([]);
  
  const addToCart = (exam) => {
    setCart([...cart, exam]);
  };
  
  const clearCart = () => {
    setCart([]);
  };
  
  const getTotalPrice = () => {
    return cart.reduce((total, item) => total + item.price, 0);
  };
  
  return (
    <CartContext.Provider value={{ cart, addToCart, clearCart, getTotalPrice }}>
      {children}
    </CartContext.Provider>
  );
};
